export default __webpack_public_path__ + "static/media/74741e1d65cadd4558f06ed6a805c4ee.svg";